import React from 'react';
import PropTypes from 'prop-types';

/**
 * NotificationBadge component displays a red badge with count for navigation items
 * @param {Object} props - Component props
 * @param {number} props.count - Number to display in badge
 * @param {number} props.maxCount - Maximum count to display before showing "9+" (default: 9)
 * @param {string} props.className - Additional CSS classes
 * @returns {JSX.Element|null} Badge component or null if count is 0
 */
const NotificationBadge = ({ count, maxCount = 9, className = '' }) => {
  // Don't render if count is 0 or negative
  if (!count || count <= 0) {
    return null;
  }

  // Format display text
  const displayText = count > maxCount ? `${maxCount}+` : count.toString();

  return (
    <span
      className={`
        inline-flex items-center justify-center
        min-w-[18px] h-[18px] px-1
        text-xs font-bold text-white
        bg-red-500 dark:bg-red-600
        rounded-full
        ring-2 ring-white dark:ring-gray-900
        shadow-sm
        transition-all duration-200
        ${className}
      `}
      aria-label={`${count} new ${count === 1 ? 'item' : 'items'}`}
      role="status"
    >
      {displayText}
    </span>
  );
};

NotificationBadge.propTypes = {
  count: PropTypes.number.isRequired,
  maxCount: PropTypes.number,
  className: PropTypes.string
};

export default NotificationBadge;